import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useExtraErrorMessage } from "./extractErrorMessage";
import { addModalErrorMessage } from "../pages/redux/circuitSlice";

type Callback = (
    error: {
        reason?: string,
        message: string
    } | Error,
    showInModal?: boolean
) => void

export function useShowError(): Callback {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const extract = useExtraErrorMessage();

    return (error, showInModal) => {
        function showMessage(
            error: {
                reason?: string,
                message: string
            }
        ) {
            if (showInModal) {
                dispatch(
                    addModalErrorMessage({
                        key: Math.random().toString(),
                        reason: error.reason,
                        message: error.message
                    })
                );
            } else {
                enqueueSnackbar(
                    error.message,
                    {
                        variant: 'error',
                        style: { whiteSpace: 'pre-line' }
                    }
                );
            }
        }

        showMessage(extract(error));
        console.error(error);
    };
}
